export * from './auth/auth';
export * from './auth/auth.module';
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/angularfire2/auth.js
// module id = ../../../../angularfire2/auth.js
// module chunks = 3